import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Supplier, Suppliers } from '../Suppliers';
import type { IVideo } from './Videos.types';

@Identifiable
@Timestampable
@Untrackable
export class Video extends AbstractDocument<IVideo> {
  readonly collections = {};

  readonly translatable = (data: IVideo): NonNullable<IVideo['_translations']>[string] => ({
    label: data.label,
  });
}

export class Videos extends AbstractCollection<Video, IVideo> {
  static path = 'videos';

  constructor(document: Supplier) {
    super(document.collection(Videos.path), Video);
  }

  get supplier() {
    return Suppliers._.getById(this.reference.parent!.id);
  }
}
